import Vue from 'vue'
import Vuex from 'vuex'
import './../plugins/axios';
import { permissionContext, permissionIdentity, validPermissionResponse, clearPermissions } from './permissionState';
const { loadCarTypes } = require('@/utils/loadCarTypes');
const { isValidCarTypeSkuList } = require('@/utils/carTypeInsuranceSku');

Vue.use(Vuex)

let carTypeDictRequest = null;
let carTypeInsuranceSkuRequest = null;

// Tokens stay outside reactive state and are only compared, never logged.
let profileToken = null;
let profileRequest = null;
let permissionRequest = null;
let profileSequence = 0;
let permissionSequence = 0;
let sessionGeneration = 0;

function session() {
    // Match the Authorization precedence in plugins/axios.js.
    const backendToken = localStorage.getItem('bo_access_token');
    return { token: backendToken || localStorage.getItem('access_token'), isBackend: !!backendToken };
}

function invalidatePermissions(state) {
    permissionSequence++;
    permissionRequest = null;
    clearPermissions(state);
}

const store = new Vuex.Store({
    state: {
        selected_branch: {
            _id: "",
            branch_name: '',
            phone_number: '',
        },
        list: {
            branchs: [],
            car_type_dict: [],
            car_type_insurance_sku: [],
            car_type_insurance_sku_loaded: false,
            provinces: [
                "กระบี่",
                "กรุงเทพมหานคร",
                "กาญจนบุรี",
                "กาฬสินธุ์",
                "กำแพงเพชร",
                "ขอนแก่น",
                "จันทบุรี",
                "ฉะเชิงเทรา",
                "ชลบุรี",
                "ชัยนาท",
                "ชัยภูมิ",
                "ชุมพร",
                "เชียงราย",
                "เชียงใหม่",
                "ตรัง",
                "ตราด",
                "ตาก",
                "นครนายก",
                "นครปฐม",
                "นครพนม",
                "นครราชสีมา",
                "นครศรีธรรมราช",
                "นครสวรรค์",
                "นนทบุรี",
                "นราธิวาส",
                "น่าน",
                "เบตง",
                "บึงกาฬ",
                "บุรีรัมย์",
                "ปทุมธานี",
                "ประจวบคีรีขันธ์",
                "ปราจีนบุรี",
                "ปัตตานี",
                "พระนครศรีอยุธยา",
                "พะเยา",
                "พังงา",
                "พัทลุง",
                "พิจิตร",
                "พิษณุโลก",
                "เพชรบุรี",
                "เพชรบูรณ์",
                "แพร่",
                "ภูเก็ต",
                "มหาสารคาม",
                "มุกดาหาร",
                "แม่ฮ่องสอน",
                "ยโสธร",
                "ยะลา",
                "ร้อยเอ็ด",
                "ระนอง",
                "ระยอง",
                "ราชบุรี",
                "ลพบุรี",
                "ลำปาง",
                "ลำพูน",
                "เลย",
                "ศรีสะเกษ",
                "สกลนคร",
                "สงขลา",
                "สตูล",
                "สมุทรปราการ",
                "สมุทรสงคราม",
                "สมุทรสาคร",
                "สระแก้ว",
                "สระบุรี",
                "สิงห์บุรี",
                "สุโขทัย",
                "สุพรรณบุรี",
                "สุราษฎร์ธานี",
                "สุรินทร์",
                "หนองคาย",
                "หนองบัวลำภู",
                "อ่างทอง",
                "อำนาจเจริญ",
                "อุดรธานี",
                "อุตรดิตถ์",
                "อุทัยธานี",
                "อุบลราชธานี"
            ],
        },
        loading: false,
        profile: {
            name: "",
            permission: {
                user_group: ""
            }
        },
        group_permissions: {},
        group_tag: '',
        permission_identity: '',
        permissions_ready: false,
        permissions_loading: false,
        permissions_error: null,
        permissions_requested: false,
        permissions_rebootstrap_required: false,
        error: null,
    },
    getters: {
        isLoading(state) {
            return state.loading;
        },
        getError(state) {
            return state.error;
        },
        // True only for the auto-created owner group. Display hint only: the
        // backend re-checks ownership on every payment-account write.
        isBranchOwner(state) {
            return state.group_tag === 'owner';
        },
    },
    mutations: {
        setLoading(state, data) {
            state.loading = data
        },

        setBranchList(state, data) {
            state.list.branchs = data
        },

        updateBranch(state, data) {
            const index = state.list.branchs.findIndex((branch) => branch._id === data._id)
            if (index === -1) return

            const updatedBranch = JSON.parse(JSON.stringify({
                ...state.list.branchs[index],
                ...data,
            }))
            Vue.set(state.list.branchs, index, updatedBranch)
        },

        setProvincesList(state, data) {
            state.list.provinces = data
        },

        setCarTypeDict(state, data) {
            state.list.car_type_dict = data
        },
        setCarTypeInsuranceSku(state, data) {
            state.list.car_type_insurance_sku = data
            state.list.car_type_insurance_sku_loaded = true
        },

        setSelectedBranch(state, val) {
            let listFiltered = state.list.branchs.filter((el) => {
                return el._id == val
            });
            //console.log("setSelectedBranch", listFiltered[0]);
            state.selected_branch._id = listFiltered[0]._id
            state.selected_branch.branch_name = listFiltered[0].branch_name
            state.selected_branch.phone_number = listFiltered[0].phone_number
        },

        setProfile(state, data) {
            const previousContext = permissionContext(state.profile);
            const nextContext = permissionContext(data);
            if (previousContext && nextContext && previousContext !== nextContext) {
                // New tenant grants must never reach the old mounted documents.
                state.permissions_rebootstrap_required = true;
            }
            if (profileToken !== session().token || permissionIdentity(state.profile) !== permissionIdentity(data)) {
                invalidatePermissions(state);
            }
            profileSequence++;
            profileToken = session().token;
            state.profile = data;
        },
        resetSession(state) {
            sessionGeneration++;
            profileSequence++;
            profileRequest = null;
            profileToken = null;
            state.profile = { name: '', permission: { user_group: '' } };
            state.permissions_requested = false;
            state.permissions_rebootstrap_required = false;
            invalidatePermissions(state);
        },
        requirePermissionRebootstrap(state) {
            state.permissions_rebootstrap_required = true;
        },
        requestPermissions(state) {
            state.permissions_requested = true;
        },
        startPermissions(state) {
            state.permissions_loading = true;
            state.permissions_error = null;
        },
        receivePermissions(state, { identity, permission, tag }) {
            // Commit grants and metadata as one snapshot.
            state.group_permissions = permission;
            state.group_tag = tag;
            state.permission_identity = identity;
            state.permissions_ready = true;
            state.permissions_error = null;
        },
        failPermissions(state, message) {
            state.permissions_error = message;
        },
        finishPermissions(state) {
            state.permissions_loading = false;
        },

        setError(state, error) {
            state.error = error;
        }
    },
    actions: {
        onReload({ commit }) { //ON RELOAD PAGE ONLY
            commit('setLoading', true);
        },
        getBranchs: async({ commit }) => {
            try {
                const response = await Vue.prototype.$axios.post(`${Vue.prototype.$baseUrl}/branch/get_user_branch`);
                const list = response.result;
                await commit('setBranchList', list);
                if (list.length) {
                    await commit('setSelectedBranch', list[0]._id);
                }
                commit('setLoading', false);
            } catch (err) {
                console.error(err);
                commit('setLoading', false);
                // Assuming you have an error mutation
                commit('setError', err.message || 'Failed to fetch branches');
            }
        },
        getProvinces: async({ commit, state }) => {
            await Vue.prototype.$axios.post(`${Vue.prototype.$baseUrl}/get_province`)
                .then(async(res) => {
                    let list = res.result;
                    await commit('setProvincesList', list)
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        getCarTypeDict: async({ commit, state }) => {
            if (state.list.car_type_dict.length) {
                return state.list.car_type_dict;
            }
            if (carTypeDictRequest) return carTypeDictRequest;

            carTypeDictRequest = loadCarTypes(() => Vue.prototype.$axios.post(
                `${Vue.prototype.$baseUrl}/car/get_car_type_dict`
            )).then((list) => {
                commit('setCarTypeDict', list);
                commit('setError', null);
                return list;
            }).catch((error) => {
                commit('setError', error.message);
                throw error;
            });

            try {
                return await carTypeDictRequest;
            } finally {
                carTypeDictRequest = null;
            }
        },
        getCarTypeInsuranceSku: async({ commit, state }) => {
            if (state.list.car_type_insurance_sku.length) {
                return state.list.car_type_insurance_sku;
            }
            if (carTypeInsuranceSkuRequest) return carTypeInsuranceSkuRequest;

            carTypeInsuranceSkuRequest = loadCarTypes(() => Vue.prototype.$axios.post(
                `${Vue.prototype.$baseUrl}/third_insurance/get_car_type_insurance_sku`
            ), { validate: isValidCarTypeSkuList }).then((list) => {
                commit('setCarTypeInsuranceSku', list);
                return list;
            });

            try {
                return await carTypeInsuranceSkuRequest;
            } finally {
                carTypeInsuranceSkuRequest = null;
            }
        },
        getMyProfile({ commit }) {
            const auth = session();
            if (profileToken && profileToken !== auth.token) commit('resetSession');
            if (!auth.token) {
                commit('setError', 'No access token found');
                return;
            }
            const generation = sessionGeneration;
            if (profileRequest && profileRequest.token === auth.token && profileRequest.generation === generation && profileRequest.sequence === profileSequence) {
                return profileRequest.promise;
            }
            const sequence = profileSequence;
            const current = () => generation === sessionGeneration && sequence === profileSequence && session().token === auth.token;
            const request = { token: auth.token, generation, sequence };
            request.promise = Promise.resolve().then(async () => {
                try {
                    if (!current()) return;
                    const decoded = Vue.prototype.$jwt.decode(auth.token.replace('Bearer ', ''), Vue.prototype.$privateKey);
                    const userId = decoded && decoded.identity && decoded.identity._id;
                    if (!userId) throw new Error('Invalid user profile identity');
                    const body = { token: Vue.prototype.$jwt.sign({ user_id: userId }, Vue.prototype.$privateKey, { noTimestamp: true }) };
                    const url = `${Vue.prototype.$baseUrl}/${auth.isBackend ? 'backend/' : ''}users/get_by_id`;
                    const response = await Vue.prototype.$axios.post(url, body);
                    if (!current()) return;
                    if (!response.result || response.result._id !== userId) throw new Error('Invalid user profile response');
                    commit('setProfile', response.result);
                } catch (err) {
                    if (current()) commit('setError', (err && (err.error_message || err.message)) || 'Failed to fetch profile');
                } finally {
                    if (profileRequest === request) profileRequest = null;
                }
            });
            profileRequest = request;
            return request.promise;
        },
        refreshPermissionSession({ commit }) {
            commit('resetSession');
            commit('requirePermissionRebootstrap');
        },
        logout({ commit }) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('bo_access_token');
            commit('resetSession');
        },
        loadingComplete({ commit }) {
            commit('setLoading', false);
        },
        async getGroupPermissions({ commit, dispatch, state }, { force = false } = {}) {
            if (state.permissions_rebootstrap_required) return {};
            const auth = session();
            if (profileToken && profileToken !== auth.token) commit('resetSession');
            const generation = sessionGeneration;
            commit('requestPermissions');
            if (!auth.token) {
                commit('failPermissions', 'No access token found');
                return {};
            }
            if (!permissionIdentity(state.profile)) await dispatch('getMyProfile');
            // A profile request may have completed after logout/account change.
            if (generation !== sessionGeneration || session().token !== auth.token || state.permissions_rebootstrap_required) return {};
            const identity = permissionIdentity(state.profile);
            if (!identity || profileToken !== auth.token) {
                commit('failPermissions', 'User profile or permission group is unavailable');
                return {};
            }
            if (permissionRequest && permissionRequest.identity === identity && permissionRequest.token === auth.token) {
                return permissionRequest.promise;
            }
            if (!force && state.permissions_ready && state.permission_identity === identity && !state.permissions_error) {
                return state.group_permissions;
            }
            const sequence = ++permissionSequence;
            const current = () => sequence === permissionSequence && generation === sessionGeneration &&
                session().token === auth.token && permissionIdentity(state.profile) === identity && !state.permissions_rebootstrap_required;
            const request = { identity, token: auth.token };
            commit('startPermissions');
            request.promise = Promise.resolve().then(async () => {
                try {
                    if (!current()) return {};
                    const groupId = state.profile.permission.user_group;
                    const body = { token: Vue.prototype.$jwt.sign({ user_group_id: groupId }, Vue.prototype.$privateKey, { noTimestamp: true }) };
                    const response = await Vue.prototype.$axios.post(`${Vue.prototype.$baseUrl}/user_group/get_by_id`, body);
                    if (!current()) return {};
                    if (!validPermissionResponse(response, groupId)) throw new Error('Invalid permission response');
                    commit('receivePermissions', { identity, permission: response.result.permission, tag: response.result.tag || '' });
                    return state.group_permissions;
                } catch (err) {
                    if (!current()) return {};
                    commit('failPermissions', (err && (err.error_message || err.message)) || 'Failed to fetch permissions');
                    return state.group_permissions;
                } finally {
                    // An old request must not clear a newer request's loading state.
                    if (permissionRequest === request) {
                        permissionRequest = null;
                        commit('finishPermissions');
                    }
                }
            });
            permissionRequest = request;
            return request.promise;
        },
    },
    modules: {}
})

// Resume a requested load when a delayed profile arrives, including group or
// company changes. The action deduplicates callers waiting for that profile.
store.subscribe(({ type }, state) => {
    if (type === 'setProfile' && state.permissions_requested && !state.permissions_rebootstrap_required && permissionIdentity(state.profile)) {
        store.dispatch('getGroupPermissions');
    }
});

export default store;
